module.exports = __webpack_public_path__ + "static/4-231aeba71cc1d488fb19014a7be201ea.jpg";